<script lang="ts">
  interface Props {
    /** Subtle lead-in text ("Click on", "Find", etc.). */
    lead?: string;
    /** Primary line — main proper noun (city / country / region). */
    primary: string;
    /**
     * Optional secondary line shown beneath the primary in dimmer text.
     * Used for "city / country" prompts. Omit for single-line prompts.
     */
    secondary?: string;
    /**
     * Optional flag SVG URL rendered to the LEFT of the primary line.
     * Country-tap modes use this slot — the flag is a major hint for
     * the prompt itself. City-distance modes leave it undefined and
     * use `secondaryFlagUrl` instead so the flag sits next to the
     * country name on line two.
     */
    flagUrl?: string;
    /**
     * Optional flag SVG URL rendered inline with the secondary line
     * (small, supporting hint). City-distance modes pass this so the
     * country flag accompanies the country name without competing
     * with the city name on line one.
     */
    secondaryFlagUrl?: string;
    /**
     * Whether the prompt is currently the active question (true) or
     * frozen mid-result (false, shown muted while the result animates).
     */
    active?: boolean;
  }

  let {
    lead = 'Click:',
    primary,
    secondary,
    flagUrl,
    secondaryFlagUrl,
    active = true,
  }: Props = $props();
</script>

<div class="prompt" class:prompt--inactive={!active}>
  <div class="prompt__lead">{lead}</div>
  <div class="prompt__primary-row">
    {#if flagUrl}
      <!-- alt="" + aria-hidden so screen readers don't double-read
           the country name (which is already in __primary). -->
      <img class="prompt__flag" src={flagUrl} alt="" aria-hidden="true" />
    {/if}
    <div class="prompt__primary">{primary}</div>
  </div>
  {#if secondary}
    <div class="prompt__secondary-row">
      {#if secondaryFlagUrl}
        <img
          class="prompt__flag prompt__flag--secondary"
          src={secondaryFlagUrl}
          alt=""
          aria-hidden="true"
        />
      {/if}
      <div class="prompt__secondary">{secondary}</div>
    </div>
  {/if}
</div>
